function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import * as React from 'react';
import { keyframes } from '@emotion/core';
import highContrastMediaQuery from '../utils/high_contrast_media_query';
import { useTheme } from '@veneer/theme';
var slideInKeyframes = keyframes({
  from: {
    opacity: 0.01
  },
  to: {
    opacity: 1
  }
});
var slideOutKeyframes = keyframes({
  from: {
    opacity: 1
  },
  to: {
    opacity: 0.01
  }
});
var useStyles = _ref => {
  var {
    inline
  } = _ref;
  var theme = useTheme();
  return React.useMemo(() => ({
    root: _objectSpread(_objectSpread({
      backgroundColor: theme.palette.background.container,
      borderRadius: theme.borderRadius,
      boxShadow: !inline ? theme.level.level16 : undefined,
      boxSizing: 'border-box',
      display: 'flex',
      flexDirection: 'column',
      fontFamily: theme.typography.family0,
      overflow: 'hidden',
      width: 320,
      '&[data-placement="bottom"], &[data-placement="top"]': {
        margin: "".concat(theme.layout.size2, " 0")
      },
      '&[data-placement="left"], &[data-placement="right"]': {
        margin: "0 ".concat(theme.layout.size2)
      }
    }, theme.mode === 'contrast' && {
      border: "1px solid ".concat(theme.palette.foreground.default)
    }), highContrastMediaQuery(theme)),
    header: {
      alignItems: 'center',
      boxSizing: 'border-box',
      display: 'flex',
      justifyContent: 'space-between',
      padding: theme.layout.size2,
      width: '100%',
      '> span': {
        color: theme.palette.foreground.default,
        padding: '6px 0'
      },
      '> div': {
        alignItems: 'center',
        display: 'inline-flex',
        justifyContent: 'center',
        width: 36
      }
    },
    ul: {
      maxHeight: inline ? undefined : '60vh',
      overflowY: 'auto'
    },
    noNotifications: {
      fontFamily: theme.typography.family0,
      alignItems: 'center',
      color: theme.palette.foreground.medium,
      display: 'flex',
      justifyContent: 'center',
      padding: "".concat(theme.layout.size3, " ").concat(theme.layout.size3)
    },
    entering: {
      animationDuration: '200ms',
      animationName: slideInKeyframes
    },
    exiting: {
      animationDuration: '200ms',
      animationName: slideOutKeyframes
    },
    exited: {
      display: 'none'
    },
    entered: {},
    unmounted: {}
  }), [theme, inline]);
};
export default useStyles;